import React from 'react';
import * as styles from './footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Footer = props => ___EmotionJSX("div", {
  css: styles.footer
}, props.children);
export default Footer;